import { Component, ɵConsole } from "@angular/core";
import { DataService } from "../../services/data.service";
import { BusinesLogicService } from "../../services/business-logic.service";
import { DatePipe } from "@angular/common";
import { UtilsService } from "../../services/utils.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

declare var jquery: any;
declare var $: any;


@Component({
  selector: "app-deskqueue",
  templateUrl: "./deskqueue.component.html",
  styleUrls: ["./deskqueue.component.css"]
})
export class DeskQueueComponent {

  public search: string = '';
  public orderType: string = null;
  public orderReverse: boolean = false;
  public turns: Array<object> = [];
  public interval = null;

  private destroy$ = new Subject();

  getTurnsSub: any;

  constructor(public _data: DataService,
    private _blogic: BusinesLogicService,
    public datePipe: DatePipe,
    private _utils: UtilsService) { }

  ngOnInit() {
    this.getTurns();
    if (this.interval == null) {
      this.interval = setInterval(e => {
        this.getTurns();
      }, 15000)
    }
  }

  ngOnDestroy() {

    clearInterval(this.interval);
    this.destroy$.next();
    this.destroy$.complete();
  }

  public openModal() {
    $("#deskQueueModal").modal('show');
  }

  public orderBy(type: string, onlyRefresh = false): void {
    this.orderType = type;

    if (!onlyRefresh) {
      this.orderReverse = !this.orderReverse;
    }
  }

  public getTurns() {

    let params: object = {
      queue_id: this._data.session["qdesk_id"],
      session_id: this._data.session["session"]
    };

    if (this._blogic.turnInProgress && this._blogic.lastQueueData)
    {
      this.filter(this._blogic.lastQueueData);
      return;
    }


    this.getTurnsSub = this._blogic.getTurnList(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this._blogic.lastQueueData = response;

        this._blogic.turnInProgress = false;
        var actualDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss').toString();
        for (let e = 0; e < response.length; e++) {
          if (response[e]['lastredirect'] != null && !(typeof response[e]['lastredirect'] == 'number')) {
            response[e]['lastredirect'] = this._utils.getWaitTime(response[e]['lastredirect'], actualDate, false, false);
          } else {
            response[e]['lastredirect'] = this._utils.getWaitTime(response[e]['initdatetime'], actualDate, false, false);
          }

          this.filter(response);

          this.orderBy(this.orderType, true);
        }
      });
  }

  public filter(list: Array<any>) {
    let onlyActiveTurns = [];
    list.forEach(e => {
      if (e.enddatetime == null && e.printed == true && e.paused == null && parseInt(e.queue_id) == parseInt(this._data.session["qdesk_id"])) {
        onlyActiveTurns.push(e);
      }
    })
    this.turns = onlyActiveTurns;
  }

  public call(id: number = null): void {

    let params: object = {
      desk_id: this._data.session["desk"],
      queue_id: this._data.session["qdesk_id"],
      turn_id: id,
      deskuser: this._data.session["username"],
      deskoperator: this._data.session["operator"]
    };

    this._blogic.setTurn(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this._data.actionContainer = 0;
          if (response != null) {
            if (response["turn_id"] == "-1") {
              this._data.closeTurn();
            } else {
              this._data.turn = response;
            }

            $("#deskQueueModal").modal('hide');

          }

        }
      );
  }

}
